function isNumber(value) {
    return typeof value === 'number';
}

function isString(value) {
    return typeof value === 'string';
}

class ValidationService {
    constructor() {
        this.EMAIL_REGEX = /^[^\s@]+@[^\s@]{2,}\.[^\s@]{2,}$/;
        this.PHONE_NUMBER_REGEX = /^[0-9]{10}$/;
        this.ZIP_CODE_REGEX = /^[A-Za-z][0-9][A-Za-z][0-9][A-Za-z][0-9]$/;
    }

    validateEmail(value) {
        return isString(value) ? this.EMAIL_REGEX.test(value) : false;
    }

    validateIsNotEmpty(value) {
        if (isString(value)) {
            return value.trim().length !== 0;
        } else if (isNumber(value)) {
            return isFinite(value); // eslint-disable-line no-restricted-globals
        }
        return !!value;
    }

    validatePassword(value) {
        return this.validateIsNotEmpty(value) && isString(value) && value.length >= 8;
    }

    validatePhoneNumber(value) {
        return this.validateIsNotEmpty(value) && isString(value) && this.PHONE_NUMBER_REGEX.test(value);
    }

    validateZipCode(value) {
        return isString(value) ? this.ZIP_CODE_REGEX.test(value.replace(' ', '')) : false;
    }
}

export default new ValidationService();
